export default __webpack_public_path__ + "static/media/BannerVideo.54916ae1.mp4";